import { atom } from 'jotai';
export const $DOMReadyState = atom('loading');
